import React, { Component } from 'react';

function Error404() {
    return <div>
        <h3>Error 404</h3>
        <br />
        <p>
            The page you are looking for does not exist.
        </p>
    </div>;
}

export default Error404;